// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/js/rem'

//引入vuex
import store from './vuex/store'
//import store from './vuex/store'

Vue.config.productionTip = false

//引入vant

Vue.use(Vant);
import Vant from 'vant';
import 'vant/lib/vant-css/index.css';
Vue.use(Vant);

import {
  Icon
} from 'vant';
Vue.use(Icon);

import {
  NavBar
} from 'vant';
Vue.use(NavBar);
import {
  RadioGroup,
  Radio
} from 'vant';
import {
  Button
} from 'vant';
Vue.use(Button);
Vue.use(RadioGroup);
Vue.use(Radio);

//显示页面具体的标题----引入
import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)


//引入lazyload
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: require('./assets/images/loading.png'),
  loading: require('./assets/images/loading.png'),
  attempt: 1,
  // the default is ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend']
  listenEvents: ['scroll']
})


//定义全局函数
//格式化时间函数
Vue.prototype.formDate = function () {
  var timestamp = new Date();
  timestamp = timestamp.getFullYear() + '-' + (timestamp.getMonth() + 1) + '-' + timestamp.getDate() + '  ' + timestamp.getHours() + ':' + timestamp.getMinutes();
  return timestamp;
}


//全局导航，区分的
Vue.prototype.backToHome = function () {
  // debugger
  this.$router.push('/home');
}
Vue.prototype.backToDetail = function () {
  this.$router.push('/home');
}
Vue.prototype.backToPay = function () {
  this.$router.push('/pay');
}
Vue.prototype.backToMy = function () {
  this.$router.push('/my');
}
Vue.prototype.backToAddress = function () {
  this.$router.push('/addressList');
}
Vue.prototype.backToOrder = function () {
  this.$router.push('/orderList');
}
Vue.prototype.backToCart = function () {
  this.$router.push('/cart');
}
Vue.prototype.close_detail = function () {
  this.isshow_detail = true;
}

//整合成一个返回导航V
Vue.prototype.pageBack = function () {
  debugger
  var currentRoute = this.$route.name;

  console.log('currentRoute:::' + currentRoute)

  if (currentRoute == 'detail') {
    this.backToHome();
  } else if (currentRoute == '/pay') {
    this.backToDetail();
  } else if (oldRouteName == 'submit_pay') {
    this.backToPay();
    //alert('ghdsfgysdf14623654455555555');
  } else if (currentRoute == '/paysuc') {
    this.backToHome();
  } else if (currentRoute == 'cart') {
    this.backToMy();
  } else if (currentRoute == 'bookMark') {
    this.backToMy();
  } else if (currentRoute == '/orderList') {
    this.backToMy();
  } else if (currentRoute == 'listDetail') {
    this.backToOrder();
  } else if (currentRoute == 'addressList') {
    this.backToMy();
  } else if (currentRoute == 'addAddress') {
    this.backToAddress();
  } else if (currentRoute == 'my') {
    this.backToAddress();
  }
}

//判断机型
Vue.prototype.AndroisIos = function () {
  let u = navigator.userAgent;
  let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
  let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    return true;
  } else if (isIOS) {
    return false;
  }
}


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js